import React from "react";
import {
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Metrics from "../../../other/Metrics";
import ProgressBar from "../../../other/progressBar/ProgressBar";
import {
  performanceT,
  seoT,
  accessibilityT,
} from "../../../other/tooltip Text/categories";

function MainContent() {
  return (
    <Grid container justifyContent="space-evenly">
      <Grid item xs={12} sm={5.5}>
        <Stack>
          <Typography
            sx={{ display: "flex", alignItems: "center", gap: "5px" }}
          >
            <strong>Performance</strong>
            <Tooltip title={performanceT}>
              <HelpOutlineIcon fontSize="10px" />
            </Tooltip>
          </Typography>
          <ProgressBar progress="48" />
          <Metrics progress="48" />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={5.5}>
        <Stack>
          <Typography
            sx={{ display: "flex", alignItems: "center", gap: "5px" }}
          >
            <strong>Accessibility</strong>
            <Tooltip title={accessibilityT}>
              <HelpOutlineIcon fontSize="10px" />
            </Tooltip>
          </Typography>
          <ProgressBar progress="77" />
          <Metrics progress="77" />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={5.5}>
        <Stack>
          <Typography
            sx={{ display: "flex", alignItems: "center", gap: "5px" }}
          >
            <strong>SEO</strong>
            <Tooltip title={seoT}>
              <HelpOutlineIcon fontSize="10px" />
            </Tooltip>
          </Typography>
          <ProgressBar progress="92" />
          <Metrics progress="92" />
        </Stack>
      </Grid>
    </Grid>
  );
}

export default MainContent;
